import { ChangeDetectionStrategy, Component, computed, forwardRef, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { PlycaUiFilterGenericComponent } from '../../filter-generic.component';
import { FormConfig } from '@/app/components/forms/form.objects';
import { FilterDemoDTO } from '../_config/filter-generic-demo.model';
import { FilterGenericData } from '../../_config/filter-generic.model';
import { generateRandomIdentifier } from '@/app/ui.service';
import { BaseComponent } from '@/app/components/common/baseComponent/base.component';
import { HeaderActionsService } from '@/app/components/common/sub-header/header-actions.service';
import { SubHeaderComponent } from '@/app/components/common/sub-header/sub-header.component';
import { isModified } from '@/app/_infrastructure/utils/comparison/comparison.utils';

@Component({
  selector: 'plyca-ui-filter-generic-demo-two',
  templateUrl: './filter-generic-demo-two.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiFilterGenericComponent, forwardRef(() => SubHeaderComponent)]
})
export class PlycaUiFilterGenericDemoTwoComponent extends BaseComponent implements OnInit, OnDestroy {
  private _isSearchButtonEnabled: Signal<boolean> = computed(() => false);

  public model: FilterDemoDTO = new FilterDemoDTO();
  public formConfigFilters: FormConfig;
  public dataModelOnChange: FilterGenericData;
  public filterWindowHash: string;

  private readonly _headerService = inject(HeaderActionsService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.filterWindowHash = generateRandomIdentifier();
    this._loadHeaderActionsInit();
  }

  private _loadHeaderActionsInit(): void {
    this._searchButtonHeader();
    this._resetButtonHeader();
  }

  private _searchButtonHeader(): void {
    this.subscribe(
      this._headerService.addWindowAction('General.search.text', 'fas fa-lg fa-search', 'btn btn-primary btn-md', true, this.filterWindowHash, () => this._isSearchButtonEnabled()),
      () => {
        console.error('Button Search Clicked!');
      }
    );
  }

  private _resetButtonHeader(): void {
    this.subscribe(this._headerService.addWindowAction('General.clean', 'fas fa-lg fa-undo', 'btn-secondary btn-md', true, this.filterWindowHash), () => {
      this._resetResults();
    });
  }

  private _resetResults(): void {
    this.dataModelOnChange.formGroup.reset();
  }

  public valuesOnChange(event: FilterGenericData): void {
    this.dataModelOnChange = event;
    this._observeFormChanges();
  }

  private _observeFormChanges(): void {
    const formGroup = this.dataModelOnChange.formGroup;
    if (formGroup && formGroup.value) {
      this._isSearchButtonEnabled = computed(() => {
        return isModified(formGroup.value);
      });
    }
  }

  ngOnDestroy(): void {
    this._headerService.clearWindowActions(this.filterWindowHash);
    super.ngOnDestroy();
  }
}
